import type { PropsWithChildren } from "react";
import { SectionTitle } from "./SectionTitle";
import { cn } from "../utils/cn";

type Props = PropsWithChildren<{
  className?: string;
  childrenClassName?: string;
}>;

export const BulletSectionTitle = ({
  children,
  className,
  childrenClassName,
}: Props) => (
  <div className={cn("py-2 flex flex-row gap-2 items-center", className)}>
    <span className={cn("text-base font-black text-black", childrenClassName)}>
      •
    </span>
    <SectionTitle className={childrenClassName}>{children}</SectionTitle>
  </div>
);

BulletSectionTitle.displayName = "BulletSectionTitle";
